@if (!hasClicked) {
    <span
        [ngbTooltip]="expandOnClick ? 'Click the &quot;...&quot; to expand the field.' : undefined"
        class="pointer"

        (click)="$event.stopPropagation(); onClick()"
    >
        {{ lessData }}...
    </span>
}
@if (hasClicked) { <span>{{ data }}</span> }